import firebase from "../../Config/firebase";
import React, {Component} from "react";
import {
    MDBListGroupItem,
    MDBInput,
    MDBBtn
} from "mdbreact";
import classes from "./ReplyReviewList.module.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPen, faReply, faSave, faTrash} from "@fortawesome/free-solid-svg-icons";
import {isAuth} from "../../Utils/firebaseUtils";
import ReplyHistory from "./ReplyHistory";

const db = firebase.firestore()


class ReplyReviewList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            edit: false,
            postID: this.props.id,
            content: this.props.data.content,
            reviewID: this.props.reviewID,
            replyName: this.props.data.createUserName,
            replyID: this.props.data.id,

            replyReplyData: {},
            isLoadedReplyReply: false,
            History:{
                createUserName:this.props.data.createUserName,
                replyContent: this.props.data.content,
                createDate:new Date()
            },
            RepliesHistory:[],
            isEdit:this.props.data.isEdit,
            isOpen: false,

        }
    }


    async componentDidMount() {
        if (isAuth(this.props.auth)) {
            this.getCustomClaim(this.props.auth)
        }

        //is reply reply
        if (this.props.data.replyID !== '') {
            const getState = await this.props.findReplyByReplyID(this.props.data.id, this.props.data.replyID)
            if (getState.success) {
                this.setState({
                    replyReplyData: getState.data
                }, () => {
                    this.setState({
                        isLoadedReplyReply: true
                    })
                })
            }
        }
    }


    delReply = (val) => {
        db.collection("Post").doc(this.props.id)
            .collection("Review").doc(this.state.reviewID)
            .collection('Reply').doc(val)
            .delete()
        this.props.delReply(val)
    }

    editReply = () => {
        this.setState({
            edit: true
        })
    }

    onChangeReply = (value) => {
        this.setState({
            content: value
        })
    }

    saveReply = () => {
        db.collection("Post").doc(this.state.postID)
            .collection("Review").doc(this.state.reviewID)
            .collection('Reply').doc(this.props.data.id)
            .update({content: this.state.content,isEdit:true})
            .then(data=>{
                this.setState({
                    isEdit:true
                })
            })

        this.setState({
            edit: false,
        })
    }


    getCustomClaim = (auth) => {
        if (isAuth(auth)) {
            firebase.auth().currentUser.getIdTokenResult()
                .then(idTokenResult => {
                    if (idTokenResult.claims.hasOwnProperty("userName") && Array.isArray(idTokenResult.claims.userName)) {
                        let newArr = []
                        idTokenResult.claims.userName.map(e => {
                            newArr.push({
                                value: e,
                                label: e
                            })
                        })
                        this.setState({
                            userName: newArr
                        }, () => {
                            this.setState({
                                isLoadedUserName: true
                            })
                        })
                    } else {
                        this.setState({
                            userName: []
                        }, () => {
                            this.setState({
                                isLoadedUserName: true
                            })
                        })
                    }
                })
        }
    }

    addReplyHistory = () =>{
        const History = this.state.History
        db.collection("Post").doc(this.state.postID)
            .collection("Review").doc(this.state.reviewID)
            .collection('Reply').doc(this.state.replyID)
            .collection('History')
            .add(History).then(doc => {
            const newReview = {
                id: doc.id,
                content: History.content,
            }
            this.setState({
                RepliesHistory: this.state.RepliesHistory.concat(newReview),
                History: {
                    createUserName:'',
                    replyContent: '',
                    createDate: new Date(),
                }
            })

        })
    }

    changeIsOpen = () =>{
        this.setState({
            isOpen:true
        })
    }


    render() {
        return (
            <MDBListGroupItem className={this.props.isSelected? classes.ListReplyBoxSelected : classes.ListReplyBox}>

                <ReplyHistory
                    isOpen={this.state.isOpen}
                    postID={this.state.postID}
                    reviewID={this.state.reviewID}
                    replyID={this.state.replyID}
                />

                <span className={classes.ReviewCreatedUser}>
                    {'@' + this.props.data.createUserName}
                    {
                        this.state.isEdit?
                            <MDBBtn
                                className={classes.isEditBtn}
                                color={"link"}
                                onClick={()=>
                                this.changeIsOpen()
                            }>
                                已編輯
                            </MDBBtn>
                            :''
                    }
                </span>

                {
                    this.props.data.replyID !== '' ?
                        this.state.isLoadedReplyReply ?
                            <div className={classes.ReplyReplyMsg}>
                                {this.state.replyReplyData.content}
                            </div>
                            : ''
                        : ""
                }

                <div className={["form-group", classes.ReplyInput].join(' ')}>
                    <MDBInput
                        type={'textarea'}
                        name={'ReplyInput'} id={'ReplyInput'}
                        disabled={!this.state.edit}
                        onChange={(e) => this.onChangeReply(e.target.value)}
                        value={this.state.content}
                        label={this.state.edit ? "編輯回應" : ''}
                    />
                </div>

                {
                    isAuth(this.props.auth) &&
                    <button type="button" className={classes.ActionBtn}
                            onClick={()=>this.props.newReply(this.state.replyName,this.state.replyID)}>
                        <FontAwesomeIcon icon={faReply}/>
                    </button>
                }


                {
                    this.props.auth.uid === this.props.data.createUserID ?
                        <div className={classes.ReviewOptionContainer}>
                            <button type="button" className={this.state.edit ? classes.ActionBtn : classes.Edit}
                                    onClick={(e) => {
                                        this.saveReply();
                                        this.addReplyHistory();
                                    }}>
                                <FontAwesomeIcon icon={faSave}/>
                            </button>
                            <button onClick={(e) => this.editReply()} className={classes.ActionBtn}>
                                <FontAwesomeIcon icon={faPen}/>
                            </button>
                            <button onClick={(e) => this.delReply(this.props.data.id)} className={classes.ActionBtn}>
                                <FontAwesomeIcon icon={faTrash}/>
                            </button>
                        </div> : ''
                }

            </MDBListGroupItem>
        );
    }
}

export default ReplyReviewList
